import ScrollReveal from "scrollreveal";
import "./styles/index.scss";

window.jQuery(() => {
  ScrollReveal().reveal(".js-fade-in", {
    opacity: 0.2,
    delay: 400
  });

  ScrollReveal().reveal(".js-slide-left", {
    duration: 1000,
    delay: 0,
    distance: "10%",
    origin: "right"
  });

  ScrollReveal().reveal(".js-slide-right", {
    delay: 0,
    duration: 1000,
    distance: "10%",
    origin: "left"
  });

  ScrollReveal().reveal(".js-slide-up", {
    duration: 1000,
    delay: 0,
    distance: "10%",
    origin: "bottom"
  });
});
